export function trimLongWords(sentence: string, maxWordLength: number, maxLineLength: number) {
  const words = sentence.slice(0, maxLineLength).split(' ')
  let trimmedSentence = ''

  for (const word of words) {
    if (word.length > maxWordLength) {
      trimmedSentence += ' ' + word.slice(0, maxWordLength)
    } else {
      trimmedSentence += ' ' + word
    }
  }

  return trimmedSentence
}
